import { Frame, Toast } from '@shopify/polaris';
import { useCallback } from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../helpers/api';
import formatErrors from '../../helpers/format_errors';
import LocationForm from './Form';
import Api from "../../helpers/api";

const ShowLocation = () => {
    const [location, setLocation] = useState({
        billing: {},
        shipping: {},
    });
    const {locationId} = useParams();
    const [toastOptions, setToastOptions] = useState({
        active: false,
        message: 'The location has been updated.',
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect( () => {
        setLoading(true);
        api.getLocation(locationId).then ( response => {
            setLocation( response.data.data );
        }).finally(() => setLoading(false))
    }, []);

    useEffect(() => {
        if (window.location.search.includes('created=1')) {
            setToastOptions({
                active: true,
                message: 'The location has been created',
            });
        }
    }, []);

    const transferCredit = useCallback(() => {
        if (location) {
            Api
                .transferCredit(location.id)
                .then( response => {
                    setLocation(response.data.data);
                    setToastOptions({
                        active: true,
                        message: 'The credit has been transferred to customer',
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [location]);

    const handleSubmit = () => {
        setErrors({});
        setLoading(true);

        api.updateLocation(locationId, location).then((response) => {
            setToastOptions({
                ...toastOptions,
                active: true,
            });
            setLoading(false);
            setLocation(response.data.data);
        }).catch(error => {
            if ( error?.response?.status == 422 ) {
                setErrors(formatErrors( error.response.data ));
            } else {
                throw error;
            }
            setLoading(false);
        });
    }

    const onToastDismiss = useCallback(() => {
        setToastOptions({
            active: false,
            message: 'The location has been updated.',
        })
    }, [toastOptions]);

    const toastMarkup = toastOptions.active ? (
        <Toast content={toastOptions.message} onDismiss={onToastDismiss} />
    ) : null;

    return location && (
        <Frame>
            <LocationForm
                customerId={location.customer_id}
                location={location}
                setLocation={setLocation}
                handleSubmit={handleSubmit}
                errors={errors}
                loading={loading}
                setLoading={setLoading}
                transferCredit={transferCredit}
            />
            {toastMarkup}
        </Frame>

    );
}

export default ShowLocation;
